import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import ConfirmedMessageModal from './ConfirmedMessage'
import AttachmentIcon from '../assets/imgs/attachment-gradient-icon.svg'
import SendIcon from '../assets/imgs/profile-screen-images/send-icon.svg'
import { Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const EmailCustomerSupportModal = ({
  handleEmailCustomerSupportModal,
  modalOpen = false,
}) => {
  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => handleEmailCustomerSupportModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="email-customer-support-modal">
          <div>
            <h3 className="fs-24 mb-3 fw-bold">Email Customer Support</h3>
            <div className="bordered-text p-2">
              <textarea
                className="customer-support-message"
                name="message"
                placeholder="Write a message"
                cols="30"
                rows="10"
              ></textarea>
              <hr className="my-1" />
              <div className="d-flex justify-content-between align-items-center mt-1">
                <img src={AttachmentIcon} alt="Attachment Icon" height={17} />
                <img src={SendIcon} alt="Send Icon" height={17} />
              </div>
            </div>
            <div
              className="mt-5 pointer"
              onClick={() => handleEmailCustomerSupportModal(false)}
            >
              <Button fullWidth id="btn-primary-no-shadow">Continue</Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default EmailCustomerSupportModal
